import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { Transport, MicroserviceOptions } from '@nestjs/microservices';
import { CustomerDbApi, CustomerDbMicroservicePort } from '@ip6m/types';
import { MicroServiceModule } from './app/modules/microservice/microservice.module';
import { DocumentBuilder, SwaggerModule } from '@nestjs/swagger';
import { ApiModule } from './app/modules/api/api.module';


async function bootstrap() {
  const microServicePort = CustomerDbMicroservicePort.default;
  const apiPort=CustomerDbApi.port;
  const microService = await NestFactory.createMicroservice<MicroserviceOptions>(
    MicroServiceModule,
    {
      transport: Transport.TCP,
      options: {
        port: microServicePort,
      }
    }
  );

  
  await microService.listen();
  Logger.log('Microservice is listening on TCP port: ' + microServicePort, 'Customer API');

  const api = await NestFactory.create(ApiModule);
  
  Logger.log('Api is listening on TCP port: ' + apiPort, 'Customer API');




  const config = new DocumentBuilder()
  .setTitle('Customer API')
  .setDescription('Service management API for GPON application')
  .setVersion('1.0.0')
  //.addTag('')
  .build();
  const document = SwaggerModule.createDocument(api, config);
  SwaggerModule.setup('api', api, document);
  
  await api.listen(apiPort);
  
}

bootstrap();
